// extracted by mini-css-extract-plugin
module.exports = {"requiredFieldsLabel":"common_requiredFieldsLabel__2K9Gm","submitButton":"common_submitButton__1Q0ei"};